import { DateTime } from 'luxon';

import aguid from 'lib/aguid';

const bonusPeriodReadyForSignOff = ({
  link,
  bonusPeriod,
}: {
  link: string;
  bonusPeriod: BonusPeriod | BonusTypes.BonusPeriod;
}): Notifications.BasicNotification => ({
  id: aguid(),
  isBasic: true,
  type: 'BONUS_PERIOD_READY_FOR_SIGN_OFF',
  seen: false,
  read: false,
  deleted: false,
  createdOn: DateTime.utc().toISO(),
  emailSent: false,
  link,
  inAppSubject: `${bonusPeriod.label} is now ready for sign off`,
  inAppBody: `The bonus period (${bonusPeriod.label}) is now ready for sign off`,
  inAppLinkText: 'Open campaign',
  emailSubject: `${bonusPeriod.label} is now ready for sign off`,
  emailBodyLn1: `The bonus period (${bonusPeriod.label}) is now ready for sign off`,
  emailBodyLn2: '',
  emailLinkText: 'Log in to sign off',
});

export default bonusPeriodReadyForSignOff;
